import { Timestamp } from 'firebase/firestore'

import { AutosaveStatusByField } from '../../types/autosave.types'
import type { AppFormControl } from '../../../../types/form.types'

export enum PlanLevel {
  Starter = 1,
  Standard = 2,
  Advanced = 3,
  Unlimited = 4,
}

export type GeneralConfigurationAutosaveField =
  | 'pricingPlan'
  | 'infoText'
  | 'websiteUrl'
  | 'facebookUrl'
  | 'instaUrl'
  | 'contact'
  | 'pricelist'
  | 'services'
  | 'reservationPolicy'
  | 'privacyPolicy'

export interface GeneralConfigurationProps {
  control: AppFormControl
  bannerFilename: string
  logoFilename: string
  autosaveStatusByField: AutosaveStatusByField<GeneralConfigurationAutosaveField>
}

export type GeneralConfigurationForm = GeneralConfigurationType & {
  bannerFile?: File
  logoFile?: File
  notificationsPhone: { phoneNumber: string; countryCode: string }
}

export interface GeneralConfigurationType {
  pricingPlan: number
  banner: string
  logo: string
  infoText: string
  contact: string
  services: string
  pricelist: string
  reservationPolicy: string
  privacyPolicy: string
  instaUrl: string
  facebookUrl: string
  websiteUrl: string
  updatedAt: Timestamp
}
